import { z } from 'zod';

import { messages } from './StepCodeVerify.messages';

export const schema = z.object({
    setupVerificationCode: z.string().trim().min(6, { message: messages.errorSetupVerificationCode }),
});
